<div class="flex h-20 shrink-0 items-center justify-center gap-6 border-b border-gray-200 bg-white px-8">
  <app-button2 appearance="secondary-ghost" size="sm" [ariaLabel]="previousLabel()" (click)="previous.emit()">
    <app-icon name="chevron-left" [size]="18" />
  </app-button2>

  @if (label(); as label) {
    <span class="flex min-w-0 items-center gap-4 whitespace-nowrap text-base font-medium text-gray-950">
      @if (label.kind === 'day') {
        {{ label.weekday }}
        <span
          class="flex h-14 min-w-14 items-center justify-center rounded-md px-2"
          [class]="label.today ? 'bg-blue-600 text-white' : 'border border-blue-600 text-blue-600'"
        >{{ label.day }}</span>
      } @else {
        {{ label.text }}
      }
    </span>
  }

  <app-button2 appearance="secondary-ghost" size="sm" [ariaLabel]="nextLabel()" (click)="next.emit()">
    <app-icon name="chevron-right" [size]="18" />
  </app-button2>
</div>
